import type React from 'react';
import PreviewTabs from 'src/components/Tabs/PreviewTabs/PreviewTabs';
import Tab from 'src/components/Tabs/Tab';
import TabPane from 'src/components/Tabs/TabPane/TabPane';
import { INFO_PANEL_VIEW_MODEL_COMP_NAME } from 'src/constants';
import type { MediaCardHorizontalTabProps } from '../../../types';

const LargeVideoTab: React.FC<MediaCardHorizontalTabProps> = ({ itemId }) => {
  return (
    <PreviewTabs>
      <TabPane name="Info" key="1">
        <Tab
          isTwoColumn={true}
          itemId={itemId}
          edit={false}
          viewModelName={INFO_PANEL_VIEW_MODEL_COMP_NAME}
          compact={true}
        />
      </TabPane>
    </PreviewTabs>
  );
};

export default LargeVideoTab;
